import { axiosInstance } from "@/api/apiClient";
import {
  NumberApi,
  NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumbersRequest,
  NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumberUsersRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new NumberApi(undefined, BASE_API, axiosInstance);

export const listBusinessNumberUsers = async (
  payload: NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumberUsersRequest
) => {
  return api.telephonyViewsNinjaNumberNumberListBusinessNumberUsers.bind(api)(
    payload
  );
};

export const getBusinessNumbers = async (
  payload: NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumbersRequest
) => {
  return api.telephonyViewsNinjaNumberNumberListBusinessNumbers.bind(api)(
    payload
  );
};

export const getBusinessNumbersExtensionLimit = async (
  payload: NumberApiTelephonyViewsNinjaNumberNumberListBusinessNumbersRequest
) => {
  return api.telephonyViewsNinjaNumberNumberGetBusinessNumbersExtensionLimit.bind(
    api
  )(payload);
};
